import api from './api';
import { ApiResponse, unwrapApiResponse } from '@/utils/api-response.util';

/** Сесія сну клієнта (лише поля календаря) - `GET /sleep/clients/:clientId/sessions`. */
export interface ClientSleepSession {
  id: number;
  startAt: string;
  endAt: string | null;
  status: 'open' | 'closed' | 'incomplete';
  kind: 'night' | 'day' | null;
}

/** Факт сну в календарі експерта (2026-09-30): "Ліг" / "Встав" окремо, кожен у свій час; лише перегляд. */
export interface SleepCalendarFact {
  sessionId: number;
  type: 'bed' | 'wake';
  at: Date;
}

/**
 * Сесії сну клієнта за [from, to) - календар експерта, лише перегляд (редагує тільки клієнт). Потрібен дозвіл клієнта
 * "Календар: Сон" (calendar_sleep:read): без нього бекенд відповідає 403 - тоді просто без сну.
 */
export const getClientSleepSessions = async (clientId: string | number, from: Date, to: Date): Promise<ClientSleepSession[]> => {
  const params = new URLSearchParams({ from: from.toISOString(), to: to.toISOString() });
  const response = await api.get<ApiResponse<ClientSleepSession[]>>(`/sleep/clients/${clientId}/sessions?${params.toString()}`);
  const data = unwrapApiResponse<ClientSleepSession[]>(response);
  return Array.isArray(data) ? data : [];
};

/** Факти, що потрапляють у [from, to): "Ліг" - якщо початок у проміжку, "Встав" - якщо кінець (лише в закритої сесії). */
export const sleepFactsInRange = (sessions: ClientSleepSession[], from: Date, to: Date): SleepCalendarFact[] => {
  const inRange = (at: Date) => at >= from && at < to;
  const facts: SleepCalendarFact[] = [];
  for (const session of sessions) {
    const bed = new Date(session.startAt);
    if (inRange(bed)) facts.push({ sessionId: session.id, type: 'bed', at: bed });
    if (session.endAt) {
      const wake = new Date(session.endAt);
      if (inRange(wake)) facts.push({ sessionId: session.id, type: 'wake', at: wake });
    }
  }
  return facts;
};
